import { colors } from "#app/theme/v1/colors";
import { fontSizes } from "#app/theme/v1/fontSizes";
import { Text } from "#shared/view/components/Text";
import { Button } from "#shared/view/designSystem/Button";

export const EditLink = ({
  defaultText,
  dataText,
  setIsEditing,
}: {
  defaultText: string;
  dataText: string | undefined;
  setIsEditing: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  return (
    <Button
      unstyled
      variant="subtle"
      style={style.button}
      py="xs"
      fz={fontSizes.large}
      onClick={() => setIsEditing(true)}
    >
      {dataText === "" ? <Display text={defaultText} dimmed={true} /> : <Display text={dataText} />}
    </Button>
  );
};

const style = {
  button: {
    backgroundColor: "transparent",
    height: "var(--input-size)",
    border: "none",
    cursor: "pointer",
  },
};

const Display = ({ text, dimmed = false }: { text: string | undefined; dimmed?: boolean }) => {
  return (
    <Text span={true} c={dimmed ? colors.grey?.[4] : colors.grey?.[9]} td="underline">
      {text}
    </Text>
  );
};
